import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { showToast } from '@klpkonsern/ui';

import { useGetProsjektProcessByIdQuery } from '@klp/prosjekt/services/rtkApi';
import { REGISTRERING_STATUS } from '@klp/formgenerator/interfaces';
import { ProsjektRoutes } from '../config';

export default function ProsjektRedirect() {
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const { prosjektId } = useParams<{ prosjektId: string }>();

    const {
        data: currentProcess,
        isLoading: isCurrentLoading,
        isError,
    } = useGetProsjektProcessByIdQuery(
        { prosjektId, culture: i18n.language },
        { skip: !prosjektId },
    );

    useEffect(() => {
        if (isCurrentLoading) return;

        if (isError || !currentProcess) {
            history.push(ProsjektRoutes.projectSchema());
            showToast({
                body: t('prosjekt.cantFindProjectSchema'),
                type: 'error',
            });
            return;
        }

        const isCompleted =
            currentProcess?.registreringStatus !== REGISTRERING_STATUS.NY;

        if (!currentProcess?.prosessInstansId || !prosjektId) return;

        if (isCompleted) {
            history.replace(
                ProsjektRoutes.projectSummary(
                    currentProcess?.prosessInstansId,
                    prosjektId,
                ),
            );
        } else {
            history.replace(
                ProsjektRoutes.projectSchemaSingle(
                    currentProcess?.prosessInstansId,
                    prosjektId,
                ),
            );
        }
    }, [currentProcess, isCurrentLoading, isError, history, prosjektId]);

    return null;
}
